import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05961770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "turn-banner" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Responses", -1))
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_menu_bar = _resolveComponent("menu-bar")!
  const _component_Claim = _resolveComponent("Claim")!
  const _component_Response = _resolveComponent("Response")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Version = _resolveComponent("Version")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("h3", _hoisted_1, " YOU ARE THE JUDGE ", 512), [
      [_vShow, _ctx.playerName === _ctx.game.playerTurn]
    ]),
    _createVNode(_component_menu_bar, { model: _ctx.menuItems }, null, 8, ["model"]),
    (_ctx.game.gameStarted && _ctx.playerName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.game.playerTurn) + "'s turn", 513), [
            [_vShow, _ctx.game.playerTurn]
          ]),
          _createVNode(_component_Claim, { getClaim: _ctx.getClaim }, null, 8, ["getClaim"]),
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_Response, {
              onPostResponse: _ctx.postResponse,
              onNext: _ctx.next
            }, null, 8, ["onPostResponse", "onNext"])
          ], 512), [
            [_vShow, _ctx.game.statement && _ctx.playerName]
          ]),
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.game.players.filter((p) => p.name !== _ctx.playerTurn), (player) => {
            return (_openBlock(), _createElementBlock("p", {
              key: player.name
            }, _toDisplayString(player.name) + ": " + _toDisplayString(_ctx.getResponse(player)), 1))
          }), 128)),
          (_ctx.playerName === _ctx.game.playerTurn)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "next-button",
                onClick: _ctx.next
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Next")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_Button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addingName = true))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Start or enter game")
            ]),
            _: 1
          })
        ])),
    _createVNode(_component_Dialog, {
      header: "Input Name",
      visible: _ctx.addingName,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addingName) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_InputText, {
          placeholder: "Player name",
          modelValue: _ctx.playerNameInput,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.playerNameInput) = $event)),
          onKeyup: _withKeys(_ctx.enterGame, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        _createVNode(_component_Button, {
          label: "Submit",
          onClick: _ctx.enterGame
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: "Input Statement",
      visible: _ctx.addingStatement,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addingStatement) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_InputText, {
          placeholder: "Statement",
          modelValue: _ctx.statementInput,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.statementInput) = $event)),
          onKeyup: _withKeys(_ctx.submitStatement, ["enter"])
        }, null, 8, ["modelValue", "onKeyup"]),
        _createVNode(_component_Button, {
          label: "Submit",
          onClick: _ctx.submitStatement
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Version)
  ], 64))
}